import RightSidebar from './RightSidebar'
export default RightSidebar
